import JobSearchFilters from '@/interface/JobSearchFilters';

export default (filters: JobSearchFilters, extraData) => {
  const filtersState = JSON.parse(JSON.stringify(filters));

  const formattedKeys = {
    keywords: 'keywords',
    city: 'location',
    country: 'location_country',
    radius: 'location_radius',
    salary: 'minSalary & maxSalary',
    standard: 'standard',
    channels: 'filter_by_channels',
    cities: 'filter_by_locations',
    branches: 'filter_by_branches',
    careerLevels: 'filter_by_careerLevels',
    releaseDay: 'filter_by_daysReleased',
    sources: 'filter_by_recruiter_types',
    date: 'filter_by_daysReleased',
    company: 'filter_by_company_id',
    companyNames: 'filter_by_company_name',

    searchChannels: 'search_by_channels',
    searchBranches: 'search_by_branches',

    initialSearchId: 'initialSearchId',
    refinedSearchId: 'refinedSearchId',
    lastExecutedSearch: 'lastExecutedSearch',
    searchFiltering: 'searchFiltering',
    featuredJobs: 'featuredJobs',
    desiredJobTitle: 'desiredJobTitle',

    origin: 'origin',
    // eslint-disable-next-line @typescript-eslint/camelcase
    saved_search_id: 'saved_search_id',
    // eslint-disable-next-line @typescript-eslint/camelcase
    saved_search_name: 'saved_search_name',
  };

  const data = Object.fromEntries(
    Object.entries(formattedKeys).reduce((res, [stateKey, requestKey]) => {
      const value = filtersState[stateKey];
      if (value === undefined || value === null) {
        let newValue = '';

        if (stateKey === 'locationRadius') {
          newValue = '0';
        }

        if (stateKey === 'lastExecutedSearch') {
          newValue = value;
        }

        res.push([requestKey, newValue]);
        return res;
      }

      switch (stateKey) {
        case 'keywords': {
          const formattedValue = (() => {
            let r = '';

            if (typeof value === 'string') {
              r = value;
            }
            if (Array.isArray(value)) {
              r = value.join(',');
            }

            r = r.replace(/\s*,\s*/g, ',').trim();

            return r.replace(/\/+/g, '\\/');
          })();

          res.push([requestKey, formattedValue]);
          break;
        }

        case 'sources':
        case 'cities':
        case 'careerLevels':
        case 'branches': {
          const fn = (item) => (typeof item === 'string' ? item : item.value);
          res.push([requestKey, value.map(fn).join(',')]);
          break;
        }

        case 'salary': {
          res.push(
            ['minSalary', value[0] ? value[0].value : 0 || -1],
            ['maxSalary', value[1] ? value[1].value : 0],
          );
          break;
        }

        case 'channels': {
          if (value[0]?.values === undefined) {
            res.push([requestKey, value.map(({ value: v }) => v).join(',')]);
            break;
          }

          res.push([
            requestKey,
            // eslint-disable-next-line
            // @ts-ignore
            value.map(({ values }) => values.map(({ value: v }) => v).join(',')).join(','),
          ]);
          break;
        }
        case 'radius':
        case 'country':
        case 'company': {
          res.push([requestKey, value.value]);
          break;
        }
        case 'companyNames': {
          res.push([requestKey, (value || []).map(({ label }) => label).join('###')]);
          break;
        }

        default: {
          res.push([requestKey, value]);
          break;
        }
      }

      return res;
    }, []),
  );

  // bind extra data
  Object.entries(extraData).forEach(([key, newValue]) => {
    const value = data[key];
    if (value !== undefined && value !== '') return;

    data[key] = newValue;
  });

  // page && limit
  (() => {
    const { page } = filters;
    const limit = filters.limit || extraData.searchLimit;

    data.searchLimit = limit;

    if (page) {
      data.searchStartIndex = ((filters?.page || 1) - 1) * limit;
    }
  })();

  return data;
};
